import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Router, ActivatedRoute } from '@angular/router';

import * as fromAuth from '../../../../store/auth';
import { take, withLatestFrom } from 'rxjs/operators';
import { flatten } from 'src/app/modules/shared/utils/flatten';
import { selectMergedRouteParams } from 'src/app/store/router/selectors';
import { DataScopeStatus } from '../../models/IDataScope';

@Component({
    selector: 'app-default-route',
    template: '',
    standalone: false
})
export class DefaultRouteComponent implements OnInit {
  constructor(
    private store: Store<{
      auth: fromAuth.AuthState;
    }>,
    private router: Router,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    this.store
      .select(fromAuth.selectUser)
      .pipe(withLatestFrom(this.store.select(selectMergedRouteParams)), take(1))
      .subscribe(([user, params]) => {
        if (user.roles.includes('Auditor')) {
          this.router.navigate(['/auditing']);
          return;
        }

        let locations = user.customers
          .filter(x => x.children.some(l => l.children.some(a => a.status === DataScopeStatus.Active)))
          .map(cus => cus.children);
        const firstLocation = flatten(locations)[0];
        const locId = params.locationId ? +params.locationId : firstLocation ? firstLocation.id : null;
        if (user.customers.length == 0) {
          console.error('No accessible location');
        }
        else if (!locId) {
          this.router.navigate(['/onboarding/wizard']);
        } else {
          if (this.router.url.endsWith('extra')) {
            return this.router.navigate(['locations', locId, 'audits', 'extra']);
          }
          //redirecting the one to daily audits
          if (user.customers.some(c => c.id === 1078)) {
            return this.router.navigate(['locations', locId, 'audits', 'daily']);
          }
          if (
            !this.route.snapshot.data ||
            !this.route.snapshot.data.redirectTo ||
            (this.route.snapshot.data.redirectTo.length === 1 && this.route.snapshot.data.redirectTo[0] === 'overview')
          ) {
            return this.router.navigate(['locations', locId, 'overview']);
          } else {
            this.router.navigate(['locations', locId, ...this.route.snapshot.data.redirectTo]);
          }
        }
      });
  }
}
